import { OneTimePasscodeStatus } from '@interfaces/one-time-passcode/otp.interface';
import { createAction, props } from '@ngrx/store';
import { ProcessSideStepData } from '@store/actions';

export const UpdateOTPVerification = createAction(
  '[One Time Passcode] Update Verification',
  props<{ payload: OneTimePasscodeStatus }>(),
);
